'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stateToHtml;

var _block = require('./block');

var _list = require('./list');

/**
* The function will generate html markup for given draftjs editorContent.
*/
// function transfrom state to hmtl
function stateToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];
    if (editorContent) {
        var blocks = editorContent.blocks,
            entityMap = editorContent.entityMap;

        if (blocks && blocks.length > 0) {
            var listBlocks = [];
            blocks.forEach(function (block) {
                if ((0, _list.isList)(block.type)) {
                    listBlocks.push(block);
                } else {
                    if (listBlocks.length > 0) {
                        var listHtml = (0, _list.getListMarkup)(listBlocks, entityMap, hashtagConfig, customEntityTransform);
                        html.push(listHtml);
                        listBlocks = [];
                    }
                    var blockHtml = (0, _block.getBlockMarkup)(block, entityMap, {}, directional, customEntityTransform);
                    html.push(blockHtml);
                }
            });
            if (listBlocks.length > 0) {
                var listHtml = (0, _list.getListMarkup)(listBlocks, entityMap, hashtagConfig, customEntityTransform);
                html.push(listHtml);
                listBlocks = [];
            }
        }
    }
    return html.join('');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/utils/draftToHTML/index.js
// module id = 109
// module chunks = 0